import {SchedulableTaskOptions} from "./schedulable-task-options.model";
import {IClientOptionsSettings} from "./client-options-settings.model";
import {NotificationOptionsSettings} from "./notification-settings.model";

export interface IWorkflowOptions extends SchedulableTaskOptions, NotificationOptionsSettings, IClientOptionsSettings {
    steps: IWorkflowStepOptions[];
}

export interface IWorkflowResponse {
    Url: string;
    Steps: IStepResponse[];
}

export interface IStepResponse {
    StepId: string;
    Result: Record<string, string>;
    Input?: string;
}

export class IWorkflowStepOptions {
    static AllowedActionTypes: string[] = ['Replace', 'Append', 'Prepend'];
    static AllowedStepTypes: string[] = ['Selection', 'Analysis', 'Generation', 'Transformation', 'Evaluation', 'Image'];
    static AllowedParameters: Record<string, ISelectionTypeCriteria[]> = {
        Selection: [
            { name: 'url', description: 'The url to crawl', options: [] },
            { name: 'crawlType', description: 'The type of data you are crawling', options: ['Url', 'Json', 'Xml'] },
            { name: 'limit', description: 'Limit on the amount of pages to crawl', options: [] }
        ],
        Analysis: [
            { name: 'Prompt', description: 'The prompt to send the GPT model', options: [] },
            { name: 'OutputFormat', description: 'The JSON object you are expecting returned', options: [] }
        ],
        Generation: [
            { name: 'Prompt', description: 'The prompt to send the GPT model', options: [] },
            { name: 'OutputFormat', description: 'The JSON object you are expecting returned', options: [] }
        ],
        Evaluation: [
            { name: 'Prompt', description: 'The prompt to send the GPT model', options: [] },
            { name: 'OutputFormat', description: 'The JSON object you are expecting returned', options: [] }
        ],
        Image: [
            { name: 'Prompt', description: 'The prompt to send the GPT model', options: [] },
            { name: 'OutputFormat', description: 'The JSON object you are expecting returned', options: [] }
        ],
        Transformation: [
            { name: 'Name', description: 'The url to crawl', options: [] },
            { name: 'PrimaryNode', description: 'The url to crawl', options: [] },
            { name: 'Type', description: 'The Transformer to use', options: [] },
            { name: 'Transformer', description: 'The Transformer to use', options: [] }
        ]
    };

    stepId: string;
    name: string;
    stepType: string;
    actionType: string;
    parameters: Record<string, string>;

    static FirstStep(): IWorkflowStepOptions {
        return {
            name: 'Selection Step',
            stepType: IWorkflowStepOptions.AllowedStepTypes[0],
            actionType: IWorkflowStepOptions.AllowedActionTypes[0],
            parameters: {}
        } as IWorkflowStepOptions;
    }
}

export interface ISelectionTypeCriteria {
    name: string;
    options: string[];
    description: string;
}
